import clsx from "clsx"
import styles from "@styles/Button.module.css"
import { Icon, IconName, IconSize } from "@components/icons/Icon"

export enum ButtonVariant {
  Default = "default",
  Filled = "filled",
  Destructive = "destructive",
}

export const Button = ({
  onClick,
  label,
  leadingIcon,
  trailingIcon,
  variant = ButtonVariant.Default,
  disabled = false,
  loading = false,
  type = "button",
  form,
}: {
  onClick?: () => void
  label: string
  leadingIcon?: IconName | null
  trailingIcon?: IconName | null
  variant?: ButtonVariant
  disabled?: boolean
  loading?: boolean
  /** Button type; use "submit" with form id for form submit */
  type?: "button" | "submit"
  /** Form id to submit when type="submit" */
  form?: string
}) => {
  return (
    <button
      type={type}
      form={form}
      className={clsx(
        styles.container,
        styles[variant],
        disabled && styles.disabled,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {(leadingIcon || loading) && (
        <Icon
          name={loading ? IconName.Loader : leadingIcon}
          spinning={loading}
          customColor={
            variant === ButtonVariant.Default
              ? "#171717"
              : disabled
                ? "#8f8f8f"
                : "#fff"
          }
        />
      )}
      {label && <span className={clsx("callout", styles.label)}>{label}</span>}
      {trailingIcon && (
        <Icon
          name={trailingIcon}
          customColor={
            variant === ButtonVariant.Default
              ? "#171717"
              : disabled
                ? "#8f8f8f"
                : "#fff"
          }
        />
      )}
    </button>
  )
}
